import Marquee from "react-fast-marquee";
import { projects } from "../data/site";

export const ProjectMarquee = () => (
  <div data-testid="project-marquee" className="py-10 sm:py-14 border-y border-gray-200 bg-paper overflow-hidden">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {projects.map((p) => (
        <span key={p.slug} className="flex items-center gap-12 mr-12 sm:gap-24 sm:mr-24">
          <span className="flex flex-col gap-1 whitespace-nowrap items-center text-center">
            <span className="font-serif text-2xl sm:text-4xl text-navy/15 leading-none">{p.name}</span>
            <span className="text-[10px] sm:text-xs font-semibold uppercase tracking-[0.3em] text-navy/25">{p.area}</span>
          </span>
          <span className="w-2 h-2 bg-brand/40 rotate-45 shrink-0" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);
